import * as React from "react";
import { StakeInputData, StakeModifier } from "../../../../data/models";
import { StakeButton } from "../StakeButton";
import { StakeValue } from "../StakeValue";

export class StakeHolder extends React.Component<{
    data: StakeInputData
}, {}> {
    render() {
        const {
            stakeFormatted, isMinusDisabled, isPlusDisabled
        } = this.props.data;
        return (
            <div className="rj-my-pulse-bets__stake-holder">
                <StakeButton handler={ e => {this.props.data.stakeDown(this.props.data.eventId)}}
                    isActive={isMinusDisabled}
                    modifier={StakeModifier.minus}
                />
                <StakeValue stakeValue={stakeFormatted} />
                <StakeButton handler={ e => {this.props.data.stakeUp(this.props.data.eventId)}}
                    isActive={isPlusDisabled}
                    modifier={StakeModifier.plus}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/components/StakeHolder/StakeHolder.tsx